import { render, staticRenderFns } from "./EmployeeEducationDetailCreateModal.vue?vue&type=template&id=af65edfa&scoped=true&"
import script from "./EmployeeEducationDetailCreateModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeEducationDetailCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af65edfa",
  null
  
)

export default component.exports